import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { isEmpty } from 'validate.js';

import BreederProfileNearbyCities from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfileNearbyCities';
import BreederProfileNearbyStates from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfileNearbyStates';
import BreederProfilePopularCities from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfilePopularCities';
import BreederProfilePopularStates from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfilePopularStates';
import BreederProfileBreedOverviewPages from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfileBreedOverviewPages';
import BreederProfileBreedAttributePages from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfileBreedAttributePages';
import Breadcrumbs from 'dpl/puppy_search_results/components/Breadcrumbs';

export default function SEOFooter() {
  const {
    breedId,
    breedName,
    citySlug,
    locationTitle,
    stateSlug,
    breadcrumbs,
    excludeFromCityPages
  } = useSelector(({ server }) => ({
    ...server,
    stateSlug: server.preappliedFilters?.stateSlug || server.stateSlug
  }));

  const isContinentalState = !['hawaii', 'alaska'].includes(stateSlug);

  return (
    <div className="SEOFooter">
      <div className="BreederRelatedLinks container-xxl">
        {stateSlug && !citySlug && (
          <div className={classnames({ 'mb10 mb0-lg': isContinentalState })}>
            <BreederProfileNearbyCities
              breedName={breedName}
              breedId={breedId}
              wideLayout
            />
            {isContinentalState && (
              <BreederProfileNearbyStates
                breedName={breedName}
                stateName={locationTitle}
                breedId={breedId}
                limit={excludeFromCityPages ? 25 : 10}
                wideLayout
              />
            )}
          </div>
        )}
        {citySlug && (
          <BreederProfileNearbyCities
            breedName={breedName}
            breedId={breedId}
            wideLayout
          />
        )}
        {!locationTitle && (
          <>
            <BreederProfilePopularCities
              breedName={breedName}
              breedId={breedId}
            />
            <BreederProfilePopularStates
              breedName={breedName}
              breedId={breedId}
            />
          </>
        )}
        <BreederProfileBreedAttributePages
          breedId={breedId}
          breedName={breedName}
          limit={50}
        />
        <BreederProfileBreedOverviewPages limit={10} />
      </div>
      {!isEmpty(breadcrumbs) && (
        <Breadcrumbs className="container-xxl mb6" links={breadcrumbs} />
      )}
    </div>
  );
}
